var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E20074"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1854 19.5006L28 16.4925L25.1815 13.488L25.7035 9.38759L21.6706 8.62531L19.7002 5L15.9933 6.77077L12.2847 5.00479L10.3193 8.63219L6.28696 9.39986L6.81371 13.4993L4 16.5072L6.81787 19.512L6.29527 23.6121L10.3285 24.3744L12.2983 28L16.0049 26.2289L19.7139 27.9952L21.6795 24.3672L25.7113 23.5998L25.6572 23.1801L25.1854 19.5006ZM15.9999 24.4279C11.6534 24.4279 8.13119 20.8786 8.13119 16.5C8.13119 12.1214 11.6534 8.57206 15.9999 8.57206C20.3466 8.57206 23.8685 12.1214 23.8685 16.5C23.8685 20.8786 20.3466 24.4279 15.9999 24.4279Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10C12.6919 10 10 12.9159 10 16.5C10 20.0841 12.6919 23 16 23C19.3081 23 22 20.0844 22 16.5C22 12.9156 19.3081 10 16 10ZM15.8803 19.5115L13.1194 17.017L12.5842 16.533L13.4775 15.372L15.6888 17.3695L18.8289 13.1877L19.9114 14.1413L15.8803 19.5115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaDashboard);
export default __webpack_public_path__ + "static/media/qa_dashboard.ab228968f95190b249c401a7c7488d52.svg";
export { ForwardRef as ReactComponent };